import "./Contact.css";

export default function Contact() {
  return (
    <section className="contact-section" id="contact">

      {/* HEADER */}
      <div className="contact-header">
        <span>CONTACT US</span>
        <h2>Sell Your Gold Easily</h2>
      </div>

      {/* CONTAINER */}
      <div className="contact-container">

        {/* LEFT INFO */}
        <div className="contact-info">
          <h3>Why Choose Us?</h3>

          <ul>
            <li>✔ Instant Payment</li>
            <li>✔ Best Market Price</li>
            <li>✔ No Hidden Charges</li>
            <li>✔ 100% Safe & Secure</li>
          </ul>

          <p>
            Get the best value for your gold with complete transparency and
            trusted service.
          </p>
        </div>

        {/* RIGHT FORM */}
        <div className="contact-form">

          <h3>Get Instant Quote</h3>

          <form>

            <div className="input-group">
              <input type="text" placeholder="Your Name" />
            </div>

            <div className="input-group">
              <input type="text" placeholder="Mobile Number" />
            </div>

            <div className="input-group">
              <input type="text" placeholder="City" />
            </div>

            <div className="input-group">
              <select>
                <option>Gold Purity
</option>
                <option>18K</option>
                <option>20K</option>
                <option>22K</option>
                 <option>24K</option>
              </select>
            </div>

            <div className="input-group">
              <input type="text" placeholder="Gold Weight (grams)" />
            </div>

            <button type="submit">Get Price</button>

          </form>

        </div>

      </div>

    </section>
  );
}